import BarChart from './barChart.component';

export default BarChart;